import { combineReducers } from 'redux';
import userReducer from './user';
import companyAdminReducer from './company-admin';
import viewerReducer from './viewer';
import superAdminReducer from './super-admin';
import rolePermissionSettingsReducer from './role-permission-settings';
import previewReducer from './preview';
import postsReducer from './posts';
import ideasReducer from './ideas';

import socialReducer from './social'; // Add the enhanced social reducer




const rootReducer = combineReducers({
  user: userReducer,
  companyAdmin: companyAdminReducer,
  viewer: viewerReducer,
  superAdmin: superAdminReducer,
  rolesAndPermissions: rolePermissionSettingsReducer,
  preview: previewReducer,
  post: postsReducer,
  ideas: ideasReducer,
  social: socialReducer,
  //socketViewer:socketviewerReducer,
//  session:sessionReducer,
});

export default rootReducer;
